import React, { useEffect, useState } from 'react'
import StageSelector from '../components-tests/StageSelector'
import PlanningGrid from '../components-tests/PlannigGrid'
import { useOutletContext } from 'react-router-dom'
import { ProductionOutletType } from '..'

const PCPGrid:React.FC = () => {
  const { selectedStage, setSelectedStage, setTabIndex } = useOutletContext<ProductionOutletType>()

  useEffect(() => {
    setTabIndex(0)
  }, [])
  
  return(
    <PlanningGrid 
      stageId={selectedStage}
      onSelectStage={setSelectedStage}
    />
  )
}

export default PCPGrid